import AcerPredatorHeliosNeo16 from "../assets/acer/AcerPredatorHeliosNeo16.jpeg";

const asusProducts = [
  {
    id: 1,
    name: "Acer Predator Helios Neo 16",
    image: AcerPredatorHeliosNeo16,
    specs: [
      "Intel i9-14900HX Processor",
      "32GB DDR5 RAM",
      "Windows 11",
      "1 TB SSD Nvme",
      "512GB SSD Nvme 4.0",
      " Nvidia RTX4070 8GB GPU",
      "16 2K 244 Hz display",
    ],
    price: "₹62,999",
    whatsappText: "Hi, I am interested in Acer Predator Helios Neo 16",
  },
];

export default asusProducts;
